exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._4eYKi input {\n  text-align: center;\n  padding: 0 10px;\n  color: #666;\n  height: 40px;\n  font-size: 16px;\n  border: 0;\n  border-bottom: 1px solid #e5e5e5;\n}\n._1vQZ6 {\n  cursor: pointer;\n  padding: 6px 10px;\n}\n", ""]);

// Exports
exports.locals = {
	"timePicker": "_4eYKi",
	"remove": "_1vQZ6"
};